(function () {
  "use strict";

  // Port fidèle du composant React PawTrail — mêmes constantes, même
  // géométrie de chemin, même mécanisme de révélation au scroll (cible
  // instantanée + pas-à-pas pour les gros écarts, réversible).
  var CURVE_K = 0.55;
  var PAW_SPACING = 90;
  var PERP_OFFSET = 12;
  var JITTER_POS = 4;
  var JITTER_ANGLE = 6;
  var PAW_SIZE = 36;
  var PAW_OPACITY = 0.35;
  var INITIAL_REACH = 380;
  var SCROLL_LOOKAHEAD = 0.9;
  var STEP_STAGGER_MS = 350;
  var SMALL_JUMP = 2;
  var REVEAL_MS = 250;
  var MOBILE_BREAKPOINT = 768;

  function getGeometry(width) {
    if (width < MOBILE_BREAKPOINT) {
      return { leftX: 15, rightX: 85, spacing: 70 };
    }
    return { leftX: 8, rightX: 92, spacing: PAW_SPACING };
  }

  function buildPathD(totalHeight, sectionHeight, leftX, rightX) {
    var numSections = Math.max(1, Math.ceil(totalHeight / sectionHeight));
    var prevX = rightX;
    var prevY = 0;
    var d = "M " + prevX + " " + prevY + " ";
    for (var i = 0; i < numSections; i++) {
      var endX = i % 2 === 0 ? leftX : rightX;
      var endY = Math.min((i + 1) * sectionHeight, totalHeight);
      var segH = endY - prevY;
      var c1x = prevX;
      var c1y = prevY + segH * CURVE_K;
      var c2x = endX;
      var c2y = endY - segH * CURVE_K;
      d +=
        "C " +
        c1x.toFixed(2) +
        " " +
        c1y.toFixed(2) +
        ", " +
        c2x.toFixed(2) +
        " " +
        c2y.toFixed(2) +
        ", " +
        endX.toFixed(2) +
        " " +
        endY.toFixed(2) +
        " ";
      prevX = endX;
      prevY = endY;
    }
    return d;
  }

  function seeded(i) {
    var x = Math.sin(i * 12.9898) * 43758.5453;
    return x - Math.floor(x);
  }

  function init() {
    var container = document.querySelector("[data-paw-trail]");
    if (!container) return;

    var reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    var svg = container.querySelector("svg");
    var pathEl = container.querySelector("path");
    var pawsHost = container.querySelector("[data-paw-host]");

    var paws = [];
    var visibleCount = 0;
    var targetCount = 0;
    var pawEls = [];

    function rebuild() {
      var height = document.body.scrollHeight;
      var width = container.clientWidth;
      var sectionHeight = window.innerHeight;
      var geo = getGeometry(width);

      svg.setAttribute("viewBox", "0 0 100 " + Math.max(height, 1));
      pathEl.setAttribute(
        "d",
        buildPathD(height, sectionHeight, geo.leftX, geo.rightX)
      );
      var len = pathEl.getTotalLength();

      paws = [];
      var i = 0;
      for (var dist = 0; dist <= len; dist += geo.spacing) {
        var p0 = pathEl.getPointAtLength(dist);
        var p1 = pathEl.getPointAtLength(Math.min(dist + 1, len));
        var dxPx = ((p1.x - p0.x) / 100) * width;
        var dyPx = p1.y - p0.y;
        var angleDeg = (Math.atan2(dyPx, dxPx) * 180) / Math.PI;

        var perp = i % 2 === 0 ? PERP_OFFSET : -PERP_OFFSET;
        var jx = (seeded(i) - 0.5) * 2 * JITTER_POS;
        var jy = (seeded(i + 137) - 0.5) * 2 * JITTER_POS;
        var jr = (seeded(i + 271) - 0.5) * 2 * JITTER_ANGLE;

        paws.push({
          top: p0.y + jy,
          left: (p0.x / 100) * width + perp + jx,
          rotate: angleDeg + 90 + jr,
        });
        i++;
      }

      targetCount = 0;
      visibleCount = 0;
      pawsHost.innerHTML = "";
      pawEls = paws.map(function () {
        var el = document.createElement("div");
        el.className = "absolute";
        el.style.transition = reducedMotion
          ? "none"
          : "opacity " +
            REVEAL_MS +
            "ms ease-out, transform " +
            REVEAL_MS +
            "ms ease-out";
        var icon = document.createElement("span");
        icon.className = "flex items-center justify-center leading-none";
        icon.style.width = PAW_SIZE + "px";
        icon.style.height = PAW_SIZE + "px";
        icon.style.fontSize = PAW_SIZE + "px";
        icon.style.filter = "brightness(0)";
        icon.textContent = "🐾";
        el.appendChild(icon);
        pawsHost.appendChild(el);
        return el;
      });
      render();
    }

    function render() {
      for (var i = 0; i < paws.length; i++) {
        var paw = paws[i];
        var el = pawEls[i];
        var isVisible = reducedMotion || i < visibleCount;
        el.style.top = paw.top + "px";
        el.style.left = paw.left + "px";
        el.style.opacity = isVisible ? PAW_OPACITY : 0;
        el.style.transform =
          "translate(-50%, -50%) rotate(" +
          paw.rotate +
          "deg) scale(" +
          (isVisible ? 1 : 0.85) +
          ")";
      }
    }

    function updateProgress() {
      var reach = Math.max(
        window.scrollY + window.innerHeight * SCROLL_LOOKAHEAD,
        INITIAL_REACH
      );
      var target = 0;
      for (var i = 0; i < paws.length; i++) {
        if (paws[i].top <= reach) target++;
      }
      targetCount = target;
      if (Math.abs(target - visibleCount) <= SMALL_JUMP) {
        visibleCount = target;
        render();
      }
    }

    if (reducedMotion) {
      rebuild();
      targetCount = paws.length;
      visibleCount = paws.length;
      render();
      return;
    }

    rebuild();

    var ticking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            updateProgress();
          });
        }
      },
      { passive: true }
    );

    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(rebuild, 200);
    });

    var ro = new ResizeObserver(function () {
      rebuild();
    });
    ro.observe(document.body);

    setInterval(function () {
      var delta = targetCount - visibleCount;
      if (delta === 0) return;
      visibleCount =
        Math.abs(delta) <= SMALL_JUMP ? targetCount : visibleCount + Math.sign(delta);
      render();
    }, STEP_STAGGER_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
